import { config } from "./config";

export type LocaleSpecification = { [_: string]: { [_: string]: string } };

/**
 * Locale translations for the application.
 * @maptoolkit
 */
export const locale: LocaleSpecification = {
  de: {
    // maplibre-gl
    "AttributionControl.ToggleAttribution": "Attribution ein-/ausblenden",
    "AttributionControl.MapFeedback": "Feedback zur Karte",
    "FullscreenControl.Enter": "Vollbild einschalten",
    "FullscreenControl.Exit": "Vollbild ausschalten",
    "GeolocateControl.FindMyLocation": "Suche meinen Standort",
    "GeolocateControl.LocationNotAvailable": "Standort nicht verfügbar",
    "LogoControl.Title": "MapLibre Logo",
    "Map.Title": "Karte",
    "Marker.Title": "Kartenmarker",
    "NavigationControl.ResetBearing": "Nach Norden ausrichten",
    "NavigationControl.ZoomIn": "Einzoomen",
    "NavigationControl.ZoomOut": "Auszoomen",
    "Popup.Close": "Popup schließen",
    "ScaleControl.Feet": "ft",
    "ScaleControl.Meters": "m",
    "ScaleControl.Kilometers": "km",
    "ScaleControl.Miles": "mi",
    "ScaleControl.NauticalMiles": "nm",
    "TerrainControl.Enable": "Terrain einschalten",
    "TerrainControl.Disable": "Terrain ausschalten",
    "CooperativeGesturesHandler.WindowsHelpText": "Strg + Scroll um zu zoomen",
    "CooperativeGesturesHandler.MacHelpText": "⌘ + Scroll um zu zoomen",
    "CooperativeGesturesHandler.MobileHelpText": "Benutze zwei Finger um die Karte zu bewegen",
    // maptoolkit
    "TerrainControl.ToggleTilt": "Karte kippen und Terrain umschalten, versuche Strg + Ziehen",
    "PitchControl.ChangePitch": "Ziehen um Karte zu kippen",
    "CompassControl.ResetBearing": "Nach Norden ausrichten",
    "CompassControl.RotateLeft": "-90\u00B0 drehen, versuche Strg + Ziehen",
    "CompassControl.RotateRight": "+90\u00B0 drehen, versuche Strg + Ziehen",
    "StyleControl.Group.Styles": "Styles",
    "StyleControl.Group.Layers": "Ebenen",
    "StyleControl.Style.Terrain": "Terrain",
    "StyleControl.Style.Light": "Light",
    "StyleControl.Style.Dark": "Dark",
    "StyleControl.Style.City": "CityMaps",
    "StyleControl.Style.Green": "Green",
    "StyleControl.Style.Winter": "Winter",
    "StyleControl.Style.Satellite": "Satellit",
    "StyleControl.Style.Hiking": "Wandern",
    "StyleControl.Style.Cycling": "Fahrrad",
    "StyleControl.Style.Pistes": "Schi",
    "StyleControl.Style.Protected": "Naturschutzgebiete",
    "StyleControl.Style.Oepnv": "ÖPNV",
    "IsochroneControl.Tooltip.foot": "Zieh' mich auf die Karte, um {range} Min-Fußweg anzuzeigen",
    "IsochroneControl.Tooltip.bike": "Zieh' mich auf die Karte, um {range} Min-Radweg anzuzeigen",
    "IsochroneControl.Tooltip.car": "Zieh' mich auf die Karte, um {range} Min-Autofahrt anzuzeigen",
  },
  en: {
    // maplibre-gl
    "AttributionControl.ToggleAttribution": "Toggle attribution",
    "AttributionControl.MapFeedback": "Map feedback",
    "FullscreenControl.Enter": "Enter fullscreen",
    "FullscreenControl.Exit": "Exit fullscreen",
    "GeolocateControl.FindMyLocation": "Find my location",
    "GeolocateControl.LocationNotAvailable": "Location not available",
    "LogoControl.Title": "MapLibre logo",
    "Map.Title": "Map",
    "Marker.Title": "Map marker",
    "NavigationControl.ResetBearing": "Reset bearing to north",
    "NavigationControl.ZoomIn": "Zoom in",
    "NavigationControl.ZoomOut": "Zoom out",
    "Popup.Close": "Close popup",
    "ScaleControl.Feet": "ft",
    "ScaleControl.Meters": "m",
    "ScaleControl.Kilometers": "km",
    "ScaleControl.Miles": "mi",
    "ScaleControl.NauticalMiles": "nm",
    "TerrainControl.Enable": "Enable terrain",
    "TerrainControl.Disable": "Disable terrain",
    "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
    "CooperativeGesturesHandler.MacHelpText": "Use ⌘ + scroll to zoom the map",
    "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map",
    // maptoolkit
    "TerrainControl.ToggleTilt": "Tilt map and toggle terrain, try Ctrl + mouse drag",
    "PitchControl.ChangePitch": "Drag to change map pitch",
    "CompassControl.ResetBearing": "Reset bearing to north",
    "CompassControl.RotateLeft": "Rotate -90\u00B0, try Ctrl + mouse drag",
    "CompassControl.RotateRight": "Rotate +90\u00B0, try Ctrl + mouse drag",
    "StyleControl.Group.Styles": "Styles",
    "StyleControl.Group.Layers": "Overlays",
    "StyleControl.Style.Terrain": "Terrain",
    "StyleControl.Style.Light": "Light",
    "StyleControl.Style.Dark": "Dark",
    "StyleControl.Style.City": "CityMaps",
    "StyleControl.Style.Green": "Green",
    "StyleControl.Style.Winter": "Winter",
    "StyleControl.Style.Satellite": "Satellite",
    "StyleControl.Style.Hiking": "Hiking",
    "StyleControl.Style.Cycling": "Cycling",
    "StyleControl.Style.Pistes": "Skiing",
    "StyleControl.Style.Protected": "Protected Areas",
    "StyleControl.Style.Oepnv": "ÖPNV",
    "IsochroneControl.Tooltip.foot": "Drag me onto the map to show a {range}-min walking area.",
    "IsochroneControl.Tooltip.bike": "Drag me onto the map to show a {range}-min cycling area.",
    "IsochroneControl.Tooltip.car": "Drag me onto the map to show a {range}-min driving area.",
  },
};

/**
 * Default locale for the application.
 */
export function getDefaultLocale() {
  return locale[config.locale || "en"];
}
